export default __webpack_public_path__ + "static/media/qrcta.98c2658c.png";